import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';

function decorateMenuItems(useReactRouter, pathname, itemsProps, currentProductName = '', parentProductName = '') {
  const menuItems = [];
  let fallbackRouteList = {};
  const items = itemsProps || [];
  for (const menuItem of Object.values(items)) {
    const {
      uri,
      baseUri,
      label,
      external,
      children = null,
      product,
      order
    } = menuItem;
    const match = !external ? uri && matchPath(pathname, uri) : false;
    const newParentProductName = product || parentProductName;
    const shouldUseExternalComponent = external || newParentProductName !== currentProductName;
    // TODO: remover prop component.
    const externalProps = shouldUseExternalComponent || !useReactRouter ? {
      component: 'a',
      componentProps: {
        href: external ? uri : `${baseUri}${uri ?? ''}`,
        target: external ? '_blank' : '_self'
      }
    } : {
      isLinkComponent: true,
      component: Link,
      componentProps: {
        to: uri
      }
    };
    let selected = false;
    if (match && match.isExact) {
      selected = true;
    }
    if (!shouldUseExternalComponent) {
      fallbackRouteList[label] = {
        route: uri,
        label
      };
    }
    const [childrenMenuItens, childrenRouteList] = decorateMenuItems(useReactRouter, pathname, children, currentProductName, newParentProductName);
    fallbackRouteList = {
      ...fallbackRouteList,
      ...childrenRouteList
    };
    menuItems.push({
      title: label,
      selected,
      order,
      children: children ? childrenMenuItens : null,
      ...externalProps
    });
  }
  return [menuItems.sort((a, b) => {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  }), fallbackRouteList];
}

export { decorateMenuItems };
